import React from "react";
import { toElementProps } from "../../Element";

export function GriderStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-grider-list": {
            display: "grid",
            gridGap: "32px",
            justifyContent: "center",

            "& .title": {
                textAlign: "center",
            },

            "& .list": {
                margin: "auto",
                display: "grid",
                gridGap: "32px",
                justifyContent: "center",

                "& .row": {
                    display: "grid",
                    gridAutoFlow: "column",
                    gridGap: "32px",
                    justifyContent: "center",

                    [MobileBreakpoint]: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        "& .grider": {
                            width: "100% !important",
                        },
                    },
                },
            },

            "&.flex-wrap > .list > .row": {
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
            },
        },
    };
}

export default function Grider(props) {
    if (!props.children || props.children.length === 0) {
        return null;
    }

    const rows = [];

    if (props.mode === "flex-wrap") {
        rows.push(props.children);
    } else if (props.children.length === 4) {
        rows.push([...props.children.slice(0, 2)]);
        rows.push([...props.children.slice(2, 4)]);
    } else if (props.children.length > 4) {
        const count = 3;
        for (let i = 0, start, end; i * count < props.children.length; i++) {
            start = i * count;
            end = start + count;
            rows.push(props.children.slice(start, end));
        }
    } else {
        rows.push(props.children);
    }

    const CNGrider = ["block-grider-list"];
    props.mode === "flex-wrap" && CNGrider.push("flex-wrap");

    const elProps = toElementProps(props, { className: CNGrider });
    return (
        <div {...elProps}>
            <div className="list">
                {rows.map((items, index) => {
                    return (
                        <div key={index} className="row">
                            {items}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
